/**
 * Styled Components - Created by eduardo on 11/01/19.
 */
import styled from 'styled-components'

interface StyledProps {
  withBorder?: boolean
}

export const ColorOptionItem = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  vertical-align: middle;
`

export const ColorContent = styled.div`
  display: inline-flex;
  align-items: center;
  overflow: hidden;
`

export const ColorSwatch = styled.img`
  width: 20px;
  height: 20px;
  object-fit: cover;
  margin-right: 8px;
  flex-shrink: 0;
  clip-path: inset(3px);
  border: ${({ withBorder }: StyledProps) => withBorder ? '1px solid var(--neutral-darkest)' : 'none'};
`

export const ColorLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StatusBadge = styled.span`
  color: #ed0000;
  font-size: 9px;
  margin-left: 8px;
  white-space: nowrap;
  background: #f4f4f4;
  padding: 0 4px;
  border-radius: 4px;
  font-weight: 500;
  line-height: 20px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItemTableV2/ColorPicker/styledComponents.tsx